import React from "react";
import { Table, Button, Popconfirm, Tag, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faSync } from "@fortawesome/free-solid-svg-icons";
import VideoProductPreview from "./video-product-preview";
import StockStatusTag from "./stock-status-tag";
import VideoStatusTag from "./video-status-tag";

// Ưu tiên trạng thái "xấu nhất" để cảnh báo ở cấp video.
function worstStatus(products = []) {
    if (!products.length) return null;
    if (products.some((p) => p.status === "error")) return "error";
    if (products.some((p) => p.status === "out_of_stock")) return "out_of_stock";
    if (products.some((p) => p.status === "unknown")) return "unknown";
    return "available";
}

function VideoTable({ videos, loading, selectedRowKeys, onSelectChange, onEdit, onDelete, onRecheck }) {
    const columns = [
        { title: "ID", dataIndex: "id", key: "id", width: 70 },
        {
            title: "Video",
            key: "video",
            render: (_, r) => (
                <div className="flex gap-2 max-w-sm">
                    <img
                        src={r.thumbnail || ""}
                        alt=""
                        className="w-12 h-16 object-cover rounded bg-surface-raised flex-shrink-0"
                        onError={(e) => (e.currentTarget.style.visibility = "hidden")}
                    />
                    <div className="min-w-0">
                        <div className="font-medium truncate">{r.productName || r.caption || "-"}</div>
                        {r.author && <div className="text-xs text-content-3 truncate">@{r.author}</div>}
                        <div className="flex items-center gap-1 mt-1">
                            <VideoStatusTag status={r.videoStatus} />
                            <a href={r.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-xs">
                                Xem
                            </a>
                        </div>
                    </div>
                </div>
            ),
        },
        { title: "Danh mục", dataIndex: "categoryId", key: "categoryId", width: 120 },
        {
            title: "Sản phẩm",
            key: "products",
            width: 220,
            render: (_, r) => {
                const products = r.products || [];
                const ws = worstStatus(products);
                return (
                    <div className="flex items-center gap-2">
                        <div className="flex -space-x-2">
                            {products.slice(0, 5).map((p) => (
                                <img
                                    key={p.id}
                                    src={p.imageUrl || ""}
                                    alt=""
                                    className="w-8 h-8 rounded border border-white object-cover bg-surface-raised"
                                    onError={(e) => (e.currentTarget.style.visibility = "hidden")}
                                />
                            ))}
                        </div>
                        <Tag>{products.length} SP</Tag>
                        {ws && ws !== "available" && <StockStatusTag status={ws} />}
                    </div>
                );
            },
        },
        {
            title: "Thao tác",
            key: "action",
            width: 170,
            render: (_, r) => (
                <div className="flex gap-1">
                    <Tooltip title="Sửa">
                        <Button size="small" type="primary" icon={<FontAwesomeIcon icon={faEdit} />} onClick={() => onEdit(r)} />
                    </Tooltip>
                    <Tooltip title="Kiểm tra tồn kho">
                        <Button size="small" icon={<FontAwesomeIcon icon={faSync} />} onClick={() => onRecheck(r.id)} />
                    </Tooltip>
                    <Popconfirm title="Xoá video này?" onConfirm={() => onDelete(r.id)} okText="Xoá" cancelText="Huỷ" okButtonProps={{ danger: true }}>
                        <Button size="small" danger icon={<FontAwesomeIcon icon={faTrash} />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    return (
        <Table
            size="small"
            rowKey="id"
            loading={loading}
            dataSource={videos}
            columns={columns}
            pagination={false}
            scroll={{ x: "max-content" }}
            rowSelection={{ selectedRowKeys, onChange: onSelectChange }}
            expandable={{
                expandedRowRender: (r) =>
                    (r.products || []).length ? (
                        <div className="flex flex-col gap-2">
                            {r.products.map((p) => (
                                <VideoProductPreview key={p.id} product={p} />
                            ))}
                        </div>
                    ) : (
                        <span className="text-content-3">Chưa gắn sản phẩm</span>
                    ),
                rowExpandable: (r) => (r.products || []).length > 0,
            }}
        />
    );
}

export default VideoTable;
